
import Vue from 'vue';
import { TransformedNoCookiePage } from '~/transforms/transformPages';

export default Vue.extend({
  name: 'noCookiePage',
  props: {
    pageData: {
      type: Object as () => TransformedNoCookiePage,
      required: true,
    },
  },
});
